import React from "react";

const AdminCard = ({ title, children, className = "" }) => {
  return (
    <div
      className={`rounded-lg bg-slate-900 border border-neutral-200 mb-5 ${className}`}
    >
      {title && (
        <div className="rounded-t-lg px-2 py-3">
          <h3 className="font-semibold pl-3 text-white text-md ">{title}</h3>
        </div>
      )}
      <div className="bg-white rounded-b-lg">{children}</div>
    </div>
  );
};

export default AdminCard;
